import { useEffect, useEffectEvent, useRef, useState } from "react";
import { getCookie, setCookie } from "@litres/utils";

import { getConfig } from "lib/get-config";

import css from "./read-in-app.module.scss";

type ReaderAppQRMessage = {
  source: "reader_app_qr";
  action: "hide" | "close";
};

const isReaderAppQRMessage = (data: unknown): data is ReaderAppQRMessage => {
  if (!data || typeof data !== "object") return false;
  const d = data as Record<string, unknown>;

  return (
    d.source === "reader_app_qr" &&
    typeof d.action === "string" &&
    ["hide", "close"].includes(d.action)
  );
};

export function ReadInAppQR() {
  const { art, iframe } = getConfig();
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const [isDismissed, setIsDismissed] = useState(
    () => getCookie("read_in_app_qr_hide") === "1"
  );
  const url = new URL(`/${art}/`, import.meta.env.VITE_LITRES_URL);
  url.searchParams.set("lite", "1");
  url.searchParams.set("app_qr", "1");
  url.searchParams.set("app_qr_ab", "1");
  const src = url.toString();

  const handleMessage = useEffectEvent((event: MessageEvent) => {
    if (!isReaderAppQRMessage(event.data)) return;

    setIsDismissed(true);
    if (event.data.action === "close") {
      setCookie("read_in_app_qr_hide", "1", { expires: 0 });
    }
  });

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  if (iframe || isDismissed) {
    return null;
  }

  return (
    <div className={css.root}>
      <iframe
        ref={iframeRef}
        src={src}
        data-testid="ReadInAppQR"
        loading="lazy"
        className={css.iframe}
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}
